import { useFragment } from '@apollo/client';
import { t } from '@lingui/core/macro';
import { Box, Chip, ListItem, UserAvatar } from '@pocketlaw/tetris';
import { getAccessLevelName } from 'app/domains/filesystem/components/AccessManagement/getAccessLevelName';
import { AclAction } from 'shared/domains/apollo/generated/types';
import { DocumentUserAccessListFragmentDoc } from './DocumentUserAccessList.gql';
export function DocumentUserAccessList(props) {
    const { from } = props;
    const { data, complete } = useFragment({
        from,
        fragment: DocumentUserAccessListFragmentDoc,
        fragmentName: 'DocumentUserAccessList',
    });
    const nameFallback = t({ message: 'Deleted user', comment: 'Fallback name when user does not exist' });
    if (!complete) {
        return null;
    }
    const userAcls = data.acls.filter((acl) => !acl.actions.includes(AclAction.Traverse));
    return userAcls.map((acl) => {
        var _a, _b;
        return (<ListItem disabled key={acl.id}>
      <UserAvatar title={((_a = acl.user) === null || _a === void 0 ? void 0 : _a.name) || nameFallback} subtitle={((_b = acl.user) === null || _b === void 0 ? void 0 : _b.email) || ''} size="md"/>
      <Box ml="auto">
        <Chip label={getAccessLevelName(acl.actions)} appearance="secondary" variant="outline" size="small"/>
      </Box>
    </ListItem>);
    });
}
